<template>
  <div class="ph-footer">
    &copy;2018 风石科技 沪ICP备17047852号<br>
    沪公网安备31010502002794号
  </div>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
<style lang="less" scoped>
  .ph-footer {
    font-size: 13px;
    padding: 20px 0 20px;
    text-align: center;
    color: #bbb;
  }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue